import { Stack } from "@mui/material";
import ClientAppointmentCard from "@/components/serviceFlow/client/clientAppointmentCard";
import useSortClientVisits from "@/components/serviceFlow/client/useSortClientVisits";
import { ClientByTokenQuery } from "@/graphql/queries/clientByToken.graphql.types";

export type Visit =
  ClientByTokenQuery["clientAccessTokenByPk"]["client"]["visits"][number];

export default function AppointmentsSection({ visits }: { visits: Visit[] }) {
  const { futureVisits, pastVisits, cancelledVisits } =
    useSortClientVisits(visits);

  return (
    <Stack>
      <ClientAppointmentCard
        title="Upcoming appointments"
        visits={futureVisits}
      />
      <ClientAppointmentCard
        title="Previous appointments"
        visits={pastVisits}
      />
      <ClientAppointmentCard
        title="Cancelled appointments"
        visits={cancelledVisits}
      />
    </Stack>
  );
}
